import { useCallback, useState, useRef } from 'react';
import { changeURL } from '@/utils';

const isPointInRect = (
  x: number,
  y: number,
  element: Element | null | undefined,
  padding = 2,
) => {
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  return (
    x >= rect.left - padding &&
    x <= rect.right + padding &&
    y >= rect.top - padding &&
    y <= rect.bottom + padding
  );
};

export default () => {
  const [inDetail, setInDetail] = useState(false);
  const [inMinDetail, setInMinDetail] = useState(false);
  const [detailId, toggleSetDetailId] = useState('');
  const [detailItem, setDetailItem] = useState<any>(null);
  const [recommendActive, setRecommendActive] = useState("like")
  const [recommendCategoryId, setRecommendCategoryId] = useState([])
  const [isDetailSmall, setDetailIsSmall] = useState(document.body.clientWidth <= 1100)
  const openDetailTimer = useRef<any>(null)
  const closeDetailTimer = useRef<any>(null)
  const closeExpandWidthTimer = useRef<any>(null)
  const openIframeWidthTimer = useRef<any>(null)
  // setDetailItem 的 timer
  const setDetailItemTimer = useRef<any>(null)
  // setDetailItem 的 timer
  const [isHoverExpand, toggleIsHoverExpand] = useState(false)
  // ref
  const isHoverExpandRef = useRef(false)
  // 滚动状态标记，用于阻止滚动时触发 Popover
  const isScrollingRef = useRef(false)
  const detailTriggerRef = useRef<HTMLElement | null>(null)
  const minDetailRef = useRef<HTMLDivElement | null>(null)

  /**
   * 素材信息按钮、素材列表滚动条通道和详情浮层共同组成 hover 区域。
   */
  const isPointInDetailHoverZone = useCallback((
    x: number,
    y: number,
    includeTrigger = true,
  ) => {
    const triggerElement = detailTriggerRef.current
    const detailElement = minDetailRef.current
    if (
      (includeTrigger && isPointInRect(x, y, triggerElement)) ||
      isPointInRect(x, y, detailElement)
    ) {
      return true
    }

    const materialListElement = document.getElementById('MaterialList')
    if (materialListElement) {
      const listRect = materialListElement.getBoundingClientRect()
      const scrollbarWidth = Math.max(
        materialListElement.offsetWidth - materialListElement.clientWidth,
        8,
      )
      if (
        x >= listRect.right - scrollbarWidth - 2 &&
        x <= listRect.right + 2 &&
        y >= listRect.top - 2 &&
        y <= listRect.bottom + 2
      ) {
        return true
      }
    }

    if (!triggerElement || !detailElement) return false
    const triggerRect = triggerElement.getBoundingClientRect()
    const detailRect = detailElement.getBoundingClientRect()
    const corridorLeft = Math.min(triggerRect.right, detailRect.left)
    const corridorRight = Math.max(triggerRect.right, detailRect.left)
    return (
      x >= corridorLeft - 2 &&
      x <= corridorRight + 2 &&
      y >= triggerRect.top - 4 &&
      y <= triggerRect.bottom + 4
    )
  }, [])

  // 包装一下setIsHoverExpand
  const setIsHoverExpand = useCallback((val: boolean) => {
    isHoverExpandRef.current = val
    toggleIsHoverExpand(val)
  }, [])
  const setDetailId = useCallback((val: any, append: boolean = true) => {
    if (append) {
      changeURL('detailId', val)
    }
    toggleSetDetailId(val) 
  }, [])
  const [offsetTop, setOffsetTop] = useState<number>(0);
  // 卡片详情的信息
  const [cardDetailInfo, setCardDetailInfo] = useState<any>(null)

  return {
    inDetail,
    setInDetail,
    detailId,
    setDetailId,
    detailItem,
    setDetailItem,
    recommendActive,
    setRecommendActive,
    recommendCategoryId,
    setRecommendCategoryId,
    isDetailSmall,
    setDetailIsSmall,
    openDetailTimer,
    closeDetailTimer,
    isHoverExpand,
    setIsHoverExpand,
    inMinDetail,
    setInMinDetail,
    isHoverExpandRef,
    openIframeWidthTimer,
    closeExpandWidthTimer,
    setDetailItemTimer,
    offsetTop,
    setOffsetTop,
    cardDetailInfo,
    setCardDetailInfo,
    isScrollingRef,
    detailTriggerRef,
    minDetailRef,
    isPointInDetailHoverZone
  }
}
